<wbo-search-page (prepareInitialFilter)="prepareInitialFilter()" (onAddNew)="addNew($event)" (editing)="onEdit($event)"
                 [editPage]="editPage"
                 [title]="'\'' + accountName + '\''"
                 [description]="'wbo.' + searchModel.getResource() + '.search.title'">
    <wbo-search-form>
        <wbo-search-form-fields>
        </wbo-search-form-fields>
    </wbo-search-form>
    <wbo-search-grid>
        <wbo-main-search-column field="receiptNo"></wbo-main-search-column>
        <wbo-date-time-column field="paymentDate"></wbo-date-time-column>
        <wbo-column field="details"></wbo-column>
        <wbo-percentage-column field="discount"></wbo-percentage-column>
        <wbo-currency-column field="credit"></wbo-currency-column>
        <wbo-currency-column field="amount"></wbo-currency-column>
        <wbo-actions-search-column>
            <wbo-void-account-payment-search-action></wbo-void-account-payment-search-action>
            <wbo-account-payment-receipt-search-action></wbo-account-payment-receipt-search-action>
        </wbo-actions-search-column>

    </wbo-search-grid>
</wbo-search-page>
